export default __webpack_public_path__ + "static/media/plain-sticker-z.a40d981e.png";